import type {PermissionsRecordType} from '../permissions';

export const employeePermissions = {
  employeeRead: {
    resourceId: 'EMPLOYEE',
    actionId: 'READ',
    scopes: [],
  },
  employeeCustomFields: {
    resourceId: 'EMPLOYEE',
    actionId: 'CUSTOM_FIELDS_PAYLOAD_UPDATE',
    scopes: [],
  },
} satisfies PermissionsRecordType;
